export default {
  height: 'auto',
  calcHeight: 100,
  tip: false,
  border: true,
  index: false,
  selection: true,
  viewBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  menuType: 'text',
  menuWidth: 250,
  column: [
    {
      label: '主键',
      prop: 'id',
      hide: true,
      viewDisplay: false,
      addDisplay: false,
      editDisplay: false,
      span: 8,
    },
    {
      label: '上级节点id',
      prop: 'parentId',
      hide: true,
      viewDisplay: false,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请选择上级节点',
          trigger: 'blur',
        },
      ],
      span: 8,
    },
    {
      label: '上级节点',
      prop: 'parentObjectName',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请选择上级节点',
          trigger: 'blur',
        },
      ],
      span: 8,
    },
    {
      label: '上级属性',
      prop: 'parentObjectTypeName',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      readonly: true,
      span: 8,
    },
    {
      label: '本级属性',
      prop: 'objectType',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=object_type',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [
        {
          required: true,
          message: '请选择上级节点',
          trigger: 'blur',
        },
      ],
      span: 8,
    },
    /*{
      label: '本级属性',
      prop: 'objectType',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      // search: true,
      rules: [
        {
          required: true,
          message: '请输入节点类型',
          trigger: 'change',
        },
      ],
      span: 8,
    },*/
    {
      label: '节点编码',
      prop: 'objectCode',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入节点编码',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '节点名称',
      prop: 'objectFullName',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      span: 8,
    },
    {
      label: '房间号',
      prop: 'objectName',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      // search: true,
      rules: [
        {
          required: true,
          message: '请输入节点名称',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '速记码',
      prop: 'shortCode',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      // search: true,
      span: 8,
    },
    {
      label: '排序序号',
      prop: 'indexNum',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          required: true,
          message: '请输入排序序号',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '房产地址',
      prop: 'roomName',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          required: true,
          message: '请输入房屋地址信息',
          trigger: 'change',
        },
      ],
      span: 24,
    },
    {
      label: '建筑面积',
      prop: 'floorage',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入建筑面积',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '使用面积',
      prop: 'usableArea',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入使用面积',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '户型',
      prop: 'roomLayout',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=room_layout',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },
    {
      label: '阁楼面积',
      prop: 'loftArea',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入阁楼面积',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '车位面积',
      prop: 'parkingArea',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入车位面积',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '加建面积',
      prop: 'additionArea',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入加建面积',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '房屋状态',
      prop: 'roomStatus',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=room_status',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },
    {
      label: '房屋性质',
      prop: 'useType',
      type: 'select',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=use_type',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },
    {
      label: '朝向',
      prop: 'roomOrientations',
      type: 'select',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=room_orientations',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },
    {
      label: '用途',
      prop: 'useDesc',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入房屋用途',
          trigger: 'change',
        },
      ],
      span: 16,
    },
    {
      label: '房屋类型',
      prop: 'roomType',
      type: 'select',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=room_type',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },
    {
      label: '户主名称',
      prop: 'householdName',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          required: true,
          message: '请输入户主名称',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '性别',
      prop: 'householdSex',
      type: 'select',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=sex',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },
    {
      label: '联系电话',
      prop: 'householdLinkPhone',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          required: true,
          message: '请输入户主联系电话',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '身份证',
      prop: 'householdIdCard',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入户主身份证',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: '邮箱',
      prop: 'householdEmail',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入户主邮箱',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    {
      label: 'QQ',
      prop: 'householdQQ',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          // required: true,
          message: '请输入户主QQ',
          trigger: 'change',
        },
      ],
      span: 8,
    },
    /*{
      label: '联系地址',
      prop: 'householdAddress',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      rules: [
        {
          required: true,
          message: '请输入户主联系地址',
          trigger: 'change',
        },
      ],
      span: 24,
    },*/
    /*{
      label: '备注',
      prop: 'remark1',
      hide: false,
      addDisplay: false,
      editDisplay: false,
      rules: [
        {
          message: '请输入备注',
          trigger: 'change',
        },
      ],
    },*/
  ],
};
